export default __webpack_public_path__ + "static/media/screen2.a6709cb2.png";